import { render, staticRenderFns } from "./SearchOnActionNew.vue?vue&type=template&id=0b8f3a22"
import script from "./SearchOnActionNew.vue?vue&type=script&lang=ts"
export * from "./SearchOnActionNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8f3a22')) {
      api.createRecord('0b8f3a22', component.options)
    } else {
      api.reload('0b8f3a22', component.options)
    }
    module.hot.accept("./SearchOnActionNew.vue?vue&type=template&id=0b8f3a22", function () {
      api.rerender('0b8f3a22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SearchOnActionNew.vue"
export default component.exports